import { FormattedNumber } from 'i18n'

import * as api from 'api'
import { currencyFromSymbol } from 'shared/currency-utilities'
import Button from '@components/Button'
import PriceBreakdownModal from '@components/PriceBreakdownModal'

import { removeFromBasket, setAutoRenew, redeemPromoCode, removePromoCode } from '../actions'
import { basketSelector, totalSelector, makePurchasePendingSelector, addressToStringSelector } from '../selectors'
import Item from './Item'

const Header = () => (
    <div className="table-header">
        <div className="transaction">
            <T>basket.transaction.label</T>
        </div>
        <div className="vehicle">
            <T>basket.vehicle.label</T>
        </div>
        <div className="period">
            <T>basket.period.label</T>
        </div>
        <div className="promo-code" />
        <div className="total">
            <T>basket.total.label</T>
        </div>
        <div className="remove" />
    </div>
)

const Contents = ({
    basket,
    total,
    pending,
    removeFromBasket,
    redeemPromoCode,
    removePromoCode,
    setAutoRenew,
    makePurchasePending,
    priceBreakdownModalOpen,
    setPriceBreakdownModalOpen,
    makePurchase,
    disabled,
    error,
}) => (
    <div>
        <div className="table basket-contents">
            <Header />
            {basket.items.map(item => (
                <Item
                    item={item}
                    promoCodePending={pending[`redeemPromoCode${item.id}`]}
                    makePurchasePending={makePurchasePending}
                    removeFromBasket={removeFromBasket}
                    setAutoRenew={setAutoRenew}
                    redeemPromoCode={redeemPromoCode}
                    removePromoCode={removePromoCode}
                    key={item.id}
                />
            ))}
        </div>
        {basket.items.length > 0 && (
            <div className="summary-total">
                <Button
                    className="ml-auto mb-2"
                    size="small"
                    btnStyle="link"
                    onClick={() => setPriceBreakdownModalOpen(true)}>
                    <T>price.breakdown</T>
                </Button>
                {priceBreakdownModalOpen && (
                    <PriceBreakdownModal
                        isLoading={makePurchasePending === true}
                        onClose={() => setPriceBreakdownModalOpen(false)}
                        onClick={makePurchase}
                        disabled={disabled}
                        error={error}
                    />
                )}
                <T>basket.total.to.pay.label</T>
                <span className="sum">
                    <FormattedNumber
                        value={total}
                        style="currency"
                        currency={currencyFromSymbol(basket.items[0].rate.currencySymbol)}
                    />
                </span>
            </div>
        )}
    </div>
)

const mapStateToProps = createStructuredSelector({
    basket: basketSelector,
    total: totalSelector,
    pending: api.selectors.pendingSelector,
    makePurchasePending: makePurchasePendingSelector,
    deliveryAddress: addressToStringSelector,
})

const actions = { removeFromBasket, setAutoRenew, redeemPromoCode, removePromoCode }

export default connect(mapStateToProps, actions)(Contents)
